import React, { useState, useCallback, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Grid, Cell } from 'react-md';

import Header from './../organisms/header';
import NavList from './../organisms/lists/navList';

const DefaultLayout = props => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = useCallback(() => {
    setMenuOpen(prev => !prev);
  }, []);

  const closeMenu = useCallback(() => {
    setMenuOpen(false);
  }, []);

  // Cerrar menú al cambiar de ruta
  useEffect(() => {
    setMenuOpen(false);
  }, [props.location.pathname]);

  return (
    <React.Fragment>
      <Header onToggleMenu={toggleMenu} />
      <div style={styles.wrapper}>
        {/* Overlay para cerrar menú al hacer click fuera */}
        {menuOpen && (
          <div
            className="sidebar-overlay"
            onClick={closeMenu}
          />
        )}

        {/* Sidebar / Drawer */}
        <aside className={`sidebar ${menuOpen ? 'sidebar--open' : ''}`}>
          <NavList onNavigate={closeMenu} />
        </aside>

        {/* Contenido principal */}
        <div className="main-content">
          <Grid>
            <Cell size={12}>
              {props.children}
            </Cell>
          </Grid>
        </div>
      </div>
    </React.Fragment>
  );
};

const styles = {
  wrapper: {
    backgroundColor: '#f5f6fa',
    minHeight: 'calc(100vh - 60px)',
    paddingTop: 8,
    display: 'flex',
    position: 'relative',
  },
};

export default withRouter(DefaultLayout);
